import React, { useMemo } from "react";
import { Form, Button, Row } from "react-bootstrap";
import Select from "react-select";
import Dropzone from "react-dropzone";
import ReactQuill from "react-quill";
import { map } from "lodash";
import { modules } from "../../constants/reactQuill";
import ImageUploadField from "./ImageUploadField";
import { FILETYPES, MAXSIZE } from "../../constants/challengeConstants";

function WelcomeSection({
  welcomeItem,
  onChangeScheduleItem,
  options,
  habits,
  timedChallenge,
  handleOnDropSchedule,
}) {
  // Memoize the Select values to prevent infinite loops
  const activitiesValue = useMemo(() => {
    return (welcomeItem?.activities || []).map((activity) => {
      const matchingOption = options.find(
        (option) => option.value === activity || option.value === activity.value
      );
      return (
        matchingOption || {
          value: activity,
          label: activity.label || activity,
        }
      );
    });
  }, [welcomeItem?.activities, options]);

  const habitsValue = useMemo(() => {
    return (welcomeItem?.habits || []).map((habit) => {
      const matchingOption = options.find(
        (option) => option.value === habit || option.value === habit.value
      );
      return (
        matchingOption || {
          value: habit,
          label: habit.title,
        }
      );
    });
  }, [welcomeItem?.habits, options]);

  const habitsOptions = useMemo(() => {
    return map(habits, (habit) => {
      return {
        value: habit,
        label: habit.title,
      };
    });
  }, [habits]);

  return (
    <div>
      <Form.Group>
        <label>Welcome Title</label>
        <Form.Control
          value={welcomeItem?.title || ""}
          placeholder="Welcome Title"
          type="string"
          onChange={(event) =>
            onChangeScheduleItem(event.target.value, "title", "welcome")
          }
        />
      </Form.Group>
      <Form.Group>
        <label>Welcome Description</label>
        <ReactQuill
          key={`welcome-description-${welcomeItem?._id || "new"}`}
          value={welcomeItem?.description || ""}
          onChange={(value) => {
            if (value === "<p><br></p>" || value === "<p></p>") {
              onChangeScheduleItem("", "description", "welcome");
            } else {
              onChangeScheduleItem(value, "description", "welcome");
            }
          }}
          modules={modules}
        />
      </Form.Group>
      <Form.Group>
        <label>Video Link</label>
        <Form.Control
          value={welcomeItem?.videoLink || ""}
          placeholder="Video Link"
          type="string"
          onChange={(event) =>
            onChangeScheduleItem(event.target.value, "videoLink", "welcome")
          }
        />
      </Form.Group>
      <Form.Group>
        <label>Lesson Text</label>
        <ReactQuill
          key={`welcome-lessonText-${welcomeItem?._id || "new"}`}
          value={welcomeItem?.lessonText || ""}
          onChange={(value) => {
            if (value === "<p><br></p>" || value === "<p></p>")
              onChangeScheduleItem("", "lessonText", "welcome");
            else onChangeScheduleItem(value, "lessonText", "welcome");
          }}
          modules={modules}
        />
      </Form.Group>
      <Form.Group>
        <label>Activities</label>
        <Select
          key={`welcome-activities-${welcomeItem?._id || "new"}`}
          className="react-select info"
          classNamePrefix="react-select"
          placeholder="Choose Activities"
          name="multipleSelect"
          closeMenuOnSelect={false}
          isMulti
          value={activitiesValue}
          onChange={(selectedOptions) => {
            const activitiesValues = (selectedOptions || []).map((option) => {
              return typeof option === "object" ? option.value : option;
            });
            onChangeScheduleItem(activitiesValues, "activities", "welcome");
          }}
          options={options}
        />
      </Form.Group>
      <Form.Group>
        <label>Habits</label>
        <Select
          key={`welcome-habits-${welcomeItem?._id || "new"}`}
          className="react-select info"
          classNamePrefix="react-select"
          placeholder="Choose Habits"
          name="multipleSelect"
          closeMenuOnSelect={false}
          isMulti
          value={habitsValue}
          onChange={(selectedOptions) => {
            const habitValues = (selectedOptions || []).map((option) => {
              return typeof option === "object" ? option.value : option;
            });
            onChangeScheduleItem(habitValues, "habits", "welcome");
          }}
          options={habitsOptions}
        />
      </Form.Group>
      {timedChallenge && (
        <>
          <Form.Group>
            <label>Community Post</label>
            <Form.Control
              value={welcomeItem?.communityPostText || ""}
              placeholder="Community Post"
              type="string"
              onChange={(event) =>
                onChangeScheduleItem(
                  event.target.value,
                  "communityPostText",
                  "welcome"
                )
              }
            />
          </Form.Group>
          <ImageUploadField
            label="Community Post Image"
            imageUrl={welcomeItem?.communityPostImage}
            onDrop={(files) =>
              handleOnDropSchedule && handleOnDropSchedule("welcome")(files)
            }
            onDelete={() =>
              onChangeScheduleItem("", "communityPostImage", "welcome")
            }
            accept={FILETYPES}
            maxSize={MAXSIZE}
          />
          <Form.Group>
            <label>Admin Community Post</label>
            <Form.Control
              value={welcomeItem?.adminCommunityPostText || ""}
              placeholder="Admin Community Post"
              type="string"
              onChange={(event) =>
                onChangeScheduleItem(
                  event.target.value,
                  "adminCommunityPostText",
                  "welcome"
                )
              }
            />
          </Form.Group>
          <ImageUploadField
            label="Admin Community Post Image"
            imageUrl={welcomeItem?.adminCommunityPostImage}
            onDrop={(files) =>
              handleOnDropSchedule &&
              handleOnDropSchedule("welcome", true)(files)
            }
            onDelete={() =>
              onChangeScheduleItem("", "adminCommunityPostImage", "welcome")
            }
            accept={FILETYPES}
            maxSize={MAXSIZE}
          />
        </>
      )}
    </div>
  );
}

export default WelcomeSection;
